import { filterData, log } from '../../utils/helpers'
import moment from 'moment'

export const ListingParamsPayload = (entityName, page, limit, paging, filters, codePagination) => {
  log('ListingParamsPayload', entityName, page, limit, filters)
  let ListingParams = paging ?? (!!codePagination ? {
    'Pn': page,
    'Ps': limit
  } : {
    'pageNo': entityName === 'lateSubmission' ? page - 1 : page,
    'pageSize': limit
  })
  // let newFilters = ListingParams
  // if (!!Object.keys(filters || {})?.length) {
  //   if (!!filters?.UUID) {
  //     newFilters['DocumentUUID'] = filters?.UUID
  //   }
  // }
  if (entityName === 'lateSubmission' && !(!!filters?.from || !!filters?.to)) {
    ListingParams = {
      ...ListingParams,
      'from': moment().startOf('year').utc().locale('en-us').format(),
      'to': moment().endOf('year').utc().locale('en-us').format()
    }
  }
  return { ...ListingParams, ...filterData({ ...(filters || {}), docUUID: filters?.DocumentUUID ?? null }) }
}